function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ReligiousTemplate = require('./religious.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ReligiousOverlay = /*#__PURE__*/function () {
  function ReligiousOverlay(app, mod) {
    _classCallCheck(this, ReligiousOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(ReligiousOverlay, [{
    key: "hide",
    value: function hide() {
      this.overlay.hide();
    }
  }, {
    key: "render",
    value: function render() {
      var his_self = this.mod;
      this.visible = true;

      //
      // show overlay
      //
      this.overlay.show(ReligiousTemplate());

      //
      //
      //
      var num_protestant_spaces = 0;
      var rcc = this.returnReligiousConflictChart();
      for (var key in his_self.game.spaces) {
        if (his_self.game.spaces[key].religion === 'protestant') {
          num_protestant_spaces++;
        }
      }
      if (num_protestant_spaces > 50) {
        num_protestant_spaces = 50;
      }
      var cid = 's' + num_protestant_spaces;

      //
      // list all debaters
      //
      for (var i = 0; i < his_self.game.state.debaters.length; i++) {
        var d = his_self.game.state.debaters[i];
        var committed = '';
        if (his_self.game.state.debaters[i].committed == 1) {
          committed = ' debater-commited';
        }
        var dtile = "\n                        \t<div class=\"debaters-tile debaters-tile".concat(i, " ").concat(committed, "\" data-key=\"").concat(this.mod.game.state.debaters[i].key, "\" data-id=\"").concat(this.mod.game.state.debaters[i].img, "\" style=\"background-image:url('/his/img/tiles/debaters/").concat(this.mod.game.state.debaters[i].img, "')\"></div>\n\t\t\t");
        if (d.owner === 'papacy') {
          his_self.app.browser.addElementToSelector(dtile, '.papal_debaters');
        }
        if (d.owner === 'england') {
          his_self.app.browser.addElementToSelector(dtile, '.anglican_debaters');
        }
        if (d.owner === 'hapsburg') {
          his_self.app.browser.addElementToSelector(dtile, '.calvinist_debaters');
        }
        if (d.owner === 'protestant') {
          his_self.app.browser.addElementToSelector(dtile, '.protestant_debaters');
        }
      }
      var obj = document.getElementById('religious_conflict_sheet_tile');
      obj.style.top = rcc[cid].top;
      obj.style.left = rcc[cid].left;
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var _loop = function _loop() {
        var tile_f = '/his/img/tiles/debaters/' + _this.mod.game.state.debaters[i].img;
        var tile_b = tile_f.replace('.svg', '_back.svg');
        var divsq = ".debaters-tile".concat(i);
        $(divsq).mouseover(function () {
          $(this).css('background-image', "url('".concat(tile_b, "')"));
        }).mouseout(function () {
          $(this).css('background-image', "url('".concat(tile_f, "')"));
        });
      };
      for (var i = 0; i < this.mod.game.state.debaters.length; i++) {
        _loop();
      }
    }
  }, {
    key: "returnReligiousConflictChart",
    value: function returnReligiousConflictChart() {
      var chart = {};
      chart['s0'] = {
        top: '475px',
        left: '64px'
      };
      chart['s1'] = {
        top: '475px',
        left: '140px'
      };
      chart['s2'] = {
        top: '475px',
        left: '216px'
      };
      chart['s3'] = {
        top: '475px',
        left: '292px'
      };
      chart['s4'] = {
        top: '475px',
        left: '368px'
      };
      chart['s5'] = {
        top: '475px',
        left: '444px'
      };
      chart['s6'] = {
        top: '475px',
        left: '520px'
      };
      chart['s7'] = {
        top: '475px',
        left: '596px'
      };
      chart['s8'] = {
        top: '475px',
        left: '672px'
      };
      chart['s9'] = {
        top: '475px',
        left: '748px'
      };
      chart['s10'] = {
        top: '475px',
        left: '824px'
      };
      chart['s11'] = {
        top: '475px',
        left: '900px'
      };
      chart['s12'] = {
        top: '475px',
        left: '976px'
      };
      chart['s13'] = {
        top: '558px',
        left: '64px'
      };
      chart['s14'] = {
        top: '558px',
        left: '140px'
      };
      chart['s15'] = {
        top: '558px',
        left: '216px'
      };
      chart['s16'] = {
        top: '558px',
        left: '292px'
      };
      chart['s17'] = {
        top: '558px',
        left: '368px'
      };
      chart['s18'] = {
        top: '558px',
        left: '444px'
      };
      chart['s19'] = {
        top: '558px',
        left: '520px'
      };
      chart['s20'] = {
        top: '558px',
        left: '596px'
      };
      chart['s21'] = {
        top: '558px',
        left: '672px'
      };
      chart['s22'] = {
        top: '558px',
        left: '748px'
      };
      chart['s23'] = {
        top: '558px',
        left: '824px'
      };
      chart['s24'] = {
        top: '558px',
        left: '900px'
      };
      chart['s25'] = {
        top: '558px',
        left: '976px'
      };
      chart['s26'] = {
        top: '643px',
        left: '64px'
      };
      chart['s27'] = {
        top: '643px',
        left: '140px'
      };
      chart['s28'] = {
        top: '643px',
        left: '216px'
      };
      chart['s29'] = {
        top: '643px',
        left: '292px'
      };
      chart['s30'] = {
        top: '643px',
        left: '368px'
      };
      chart['s31'] = {
        top: '643px',
        left: '444px'
      };
      chart['s32'] = {
        top: '643px',
        left: '520px'
      };
      chart['s33'] = {
        top: '643px',
        left: '596px'
      };
      chart['s34'] = {
        top: '643px',
        left: '672px'
      };
      chart['s35'] = {
        top: '643px',
        left: '748px'
      };
      chart['s36'] = {
        top: '643px',
        left: '824px'
      };
      chart['s37'] = {
        top: '643px',
        left: '900px'
      };
      chart['s38'] = {
        top: '643px',
        left: '976px'
      };
      chart['s39'] = {
        top: '475px',
        left: '64px'
      };
      chart['s40'] = {
        top: '726px',
        left: '140px'
      };
      chart['s41'] = {
        top: '726px',
        left: '216px'
      };
      chart['s42'] = {
        top: '726px',
        left: '292px'
      };
      chart['s43'] = {
        top: '726px',
        left: '368px'
      };
      chart['s44'] = {
        top: '726px',
        left: '444px'
      };
      chart['s45'] = {
        top: '726px',
        left: '520px'
      };
      chart['s46'] = {
        top: '726px',
        left: '596px'
      };
      chart['s47'] = {
        top: '726px',
        left: '672px'
      };
      chart['s48'] = {
        top: '726px',
        left: '672px'
      };
      chart['s49'] = {
        top: '726px',
        left: '748px'
      };
      chart['s50'] = {
        top: '726px',
        left: '824px'
      };
      return chart;
    }
  }]);
}();
module.exports = ReligiousOverlay;